export const scheduleEventMixin = {
    data() {
        return {
            isSchedulingEvent: false,
        };
    },

    methods: {

        scheduleEventByTemplate(eventTemplate, date, scheduleEventParams) {
            // Booking is not idempotent: a second POST books a second lesson, so a double
            // click must never reach the server twice.
            if (this.isSchedulingEvent) return;
            this.isSchedulingEvent = true;

            let start_time = moment(date).hour(eventTemplate._start_time.hour()).minute(eventTemplate._start_time.minute());
            let end_time = moment(date).hour(eventTemplate._end_time.hour()).minute(eventTemplate._end_time.minute());

            let event = {
                event_template_id: eventTemplate.id,
                title: "practice-lesson" === eventTemplate.type ? '' : eventTemplate.title,
                type: eventTemplate.type,
                start_date: start_time.format(),
                end_date: end_time.format(),
                start_time: start_time.format(),
                end_time: end_time.format(),
                is_recurring: false,
                extra_options: {},
                schedule_params: {
                    is_scheduling_event: true,
                    ...scheduleEventParams
                }
            };

            this.loading(true);

            axios
                .post(eventTemplate.store_events_url || this.storeEventsUrl, event)
                .then(response => {
                    console.log("OK", response);

                    if (response.data.event) {
                        this.eventBus.$emit('created-event', response.data.event, response.data);

                        response.data.event._parent_event_template = eventTemplate;
                        eventTemplate._created_event = response.data.event;
                    }

                    this.$notify({group: 'app', text: response.data.message, type: 'success'});
                }, error => {
                    console.log("ERROR", error.response);

                    // A network error or timeout leaves error.response undefined, so reading
                    // .data off it threw here and the user got no notification at all.
                    this.$notify({
                        group: 'app',
                        text: error?.response?.data?.message || 'A apărut o eroare. Încercați din nou.',
                        type: 'error'
                    });

                    // _LTracker.push({
                    //     'action': 'Schedule Event By Template Error',
                    //     'error': error,
                    //     'new_event': event
                    // });
                })
                .finally(() => {
                    this.isSchedulingEvent = false;
                    this.loading(false);
                });
        }
    },
};
